import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M4.5 3h15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 14h12", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Beaker";
const Beaker = memo(themed(Icon));
export {
  Beaker
};
//# sourceMappingURL=beaker.js.map
